export default "__VITE_ASSET__C_tQmN5C__"